module.exports = __webpack_public_path__ + "static/media/ic-chevron-up.b06791e3.svg";